import React from 'react';

export function ArticleIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 10v28H10V10h28zm0-4H10c-2.2 0-4 1.8-4 4v28c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4z" />
      <path d="M28 33a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h12a1 1 0 011 1v2zm6-8a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18a1 1 0 011 1v2zm0-8a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18a1 1 0 011 1v2z" />
    </svg>
  );
}
